import * as React from 'react';
export default function SvgBurger() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 5.5A2.25 2.25 0 006.5 7.75V9h11V7.75a2.25 2.25 0 00-2.25-2.25h-6.5zM5 7.75A3.75 3.75 0 018.75 4h6.5A3.75 3.75 0 0119 7.75v2a.75.75 0 01-.75.75H5.75A.75.75 0 015 9.75v-2zM5 14.75a.75.75 0 01.75-.75H12a.75.75 0 01.335.08l1.665.832 1.665-.833A.75.75 0 0116 14h2.25a.75.75 0 01.75.75v1.5A3.75 3.75 0 0115.25 20h-6.5A3.75 3.75 0 015 16.25v-1.5zm1.5.75v.75a2.25 2.25 0 002.25 2.25h6.5a2.25 2.25 0 002.25-2.25v-.75h-1.323l-1.842.92a.75.75 0 01-.67 0l-1.842-.92H6.5zM4 12.25a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H4.75a.75.75 0 01-.75-.75z",
    fill: "currentColor"
  }));
}